/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_Revoke_ConfirmInputs */

const en_us2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw and delete the photos`)
};

const pt_br2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar e apagar as fotos`)
};

const es_419_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar y borrar las fotos`)
};

const pt_pt2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar e apagar as fotos`)
};

const fr_fr2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer et supprimer les photos`)
};

const de_de2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerrufen und Fotos löschen`)
};

const it_it2_body_assessment_consent_revoke_confirm = /** @type {(inputs: Body_Assessment_Consent_Revoke_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoca ed elimina le foto`)
};

/**
* | output |
* | --- |
* | "Withdraw and delete the photos" |
*
* @param {Body_Assessment_Consent_Revoke_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoke_confirm = /** @type {((inputs?: Body_Assessment_Consent_Revoke_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_Revoke_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoke_confirm(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoke_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoke_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoke_confirm(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoke_confirm(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoke_confirm(inputs)
	return en_us2_body_assessment_consent_revoke_confirm(inputs)
});
export { body_assessment_consent_revoke_confirm as "body-assessment.consent_revoke_confirm" }